import {Component, QueryList, ViewChild, TemplateRef} from "@angular/core";
import {RadioButtonState, ControlGroup, Control, FORM_DIRECTIVES} from "@angular/common";

@Component({
  selector: "common-ngtemplateoutlet",
  template: `
  <usecase-container title="NgTemplateOutlet" src="common/ngtemplateoutlet">
    <usecase-content>
      <template #template1>
         <h1>Hello {{name}}!</h1> 
      </template>
      <template #template2>
         <h1>Hallo {{name}}!</h1> 
      </template>
      <input type="text" [(ngModel)]="name">
      <label><input type="checkbox" (change)="useSubTemplate($event.target.checked)"> Use sub template</label>
      <div [ngTemplateOutlet]="selectedTemplate">
      </div> 
    </usecase-content>
  </usecase-container>
  `,
  directives: [FORM_DIRECTIVES]
})
export class NgTemplateOutletComponent {
  @ViewChild("template1") template1: TemplateRef<any>;
  @ViewChild("template2") template2: TemplateRef<any>;

  name: string = "World";
  selectedTemplate: TemplateRef<any>;

  constructor() {
  }

  ngAfterViewInit() {
    this.useSubTemplate(false);
  }

  useSubTemplate(use: boolean) {
    setTimeout(() => { // run in next turn
      if (use) {
        this.selectedTemplate = this.template2;
      } else {
        this.selectedTemplate = this.template1;
      }
    }, 0);
  }
}



/** WEBPACK FOOTER **
 ** ./script/common/ngtemplateoutlet/component.ts
 **/